import { InjectionToken, Signal, signal } from '@angular/core';

/** Что блоку тела нужно от страницы, кроме своего содержимого: заголовок и адреса опубликованных страниц. */
export interface IBlogBlockPage {
    readonly title: string;
    readonly paths: ReadonlyMap<string, string>;
}

/**
 * Данные страницы для блоков её тела. Страница даёт их один раз, а блок читает внедрением: так блок
 * получает от рисующего его реестра одно содержимое и не требует входов, которых реестр не знает.
 */
export const BLOG_BLOCK_PAGE: InjectionToken<Signal<IBlogBlockPage>> = new InjectionToken<Signal<IBlogBlockPage>>('BLOG_BLOCK_PAGE', {
    factory: (): Signal<IBlogBlockPage> => signal<IBlogBlockPage>({ title: '', paths: new Map<string, string>() }).asReadonly(),
});
